var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-list',_vm._l((_vm.skills),function(skill){return _c('v-list-item',{key:skill.category},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"text-h5"},[_vm._v(" "+_vm._s(skill.category)+" ")]),_c('v-list-item-subtitle',{staticClass:"text-subtitle-1"},[_vm._v(" "+_vm._s(skill.items.join(', '))+" ")])],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }